<template>
  <main class="main mobile_request_view" role="main" v-if="isCompleted">
    <div class="request_progress" ref="main_con">
      <div class="progress_internet">
        <div class="prog_sec">
          <div class="prog_sec_ttl">
            <h2>견적 신청 내용</h2>
            <button v-if="isSetClosingBtn" @click="setClosing">
              견적 마감하기
            </button>
          </div>
          <div class="prog_sec_cont">
            <IngList
              :list="mobileRequestList"
              :isStatus="isStatus"
              :isType="'view'"
              :isSelectIndex="isListSelectIndex"
              :isSlideIndex="isSlideIndex"
              @setSlideIndex="setSlideIndex"
              ref="ing_list"
            ></IngList>
          </div>
        </div>
        <div class="prog_sec" v-if="supportsCount > 0 || plansCount > 0">
          <div class="prog_sec_ttl">
            <h2>견적 받은 내역</h2>
          </div>
          <div class="prog_sec_cont">
            <div class="list_vertical">
              <div class="list_pay_type_tab">
                <div
                  class="tab_btn pnt"
                  :class="{ on: selectPayType == 'SUPPORT' }"
                  ref="tab_support"
                  @click="selectTab('SUPPORT')"
                >
                  <div class="tab_title">단말할인(공시지원)</div>
                  <div class="tab_cnt">{{ supportsCount }}</div>
                </div>
                <div
                  class="tab_btn pnt"
                  :class="{ on: selectPayType == 'PLAN' }"
                  ref="tab_plan"
                  @click="selectTab('PLAN')"
                >
                  <div class="tab_title">요금할인(선택약정)</div>
                  <div class="tab_cnt">{{ plansCount }}</div>
                </div>
              </div>
              <div class="list_pay_type_txt" v-if="selectPayType == 'SUPPORT'">
                공시지원기준(단말할인) 견적을 드립니다!
              </div>
              <div
                class="list_pay_type_txt"
                v-else-if="selectPayType == 'PLAN'"
              >
                선택약정기준(요금할인) 견적을 드립니다!
              </div>
              <div class="list_order">
                <p>24개월 할부 기준</p>
                <button class="btn_order" @click="listSortOpen">
                  {{ listSortTxt }}
                </button>
              </div>
              <div
                class="list_compare_info"
                v-if="
                  selectPayType == 'SUPPORT' &&
                    supportsCount >= 2 &&
                    listSortVal == 'PRICE_ASC'
                "
              >
                <div class="img_1">
                  <img src="@/assets/front/images/v2/etc/imoji_search.png" />
                </div>
                <div class="txt_1">
                  {{ compareDataSupport[0].store }}의 견적이
                  {{ compareDataSupport[1].store }} 견적 보다<br />약정 기간
                  동안(2년) 총 납부 금액이
                  <span class="bl"
                    >{{
                      toCurrency(
                        compareDataSupport[1].totalMoney -
                          compareDataSupport[0].totalMoney,
                      )
                    }}원</span
                  >저렴해요!
                </div>
              </div>
              <div
                class="list_compare_info"
                v-if="
                  selectPayType == 'PLAN' &&
                    plansCount >= 2 &&
                    listSortVal == 'PRICE_ASC'
                "
              >
                <div class="img_1">
                  <img src="@/assets/front/images/v2/etc/imoji_search.png" />
                </div>
                <div class="txt_1">
                  {{ compareDataPlan[0].store }}의 견적이
                  {{ compareDataPlan[1].store }} 견적 보다<br />약정 기간
                  동안(2년) 총 납부 금액이
                  <span class="bl"
                    >{{
                      toCurrency(
                        compareDataPlan[1].totalMoney -
                          compareDataPlan[0].totalMoney,
                      )
                    }}원</span
                  >저렴해요!
                </div>
              </div>
              <ul class="list_vertical_ul" v-if="selectPayType == 'SUPPORT'">
                <li
                  class="list_item"
                  v-for="(item, index) in mobileEstimateGroupList.content
                    .supports"
                  :key="index"
                >
                  <div
                    class="tag"
                    :class="{ best: index === 0 }"
                    v-if="index < 2"
                  >
                    <p>{{ index + 1 }}등</p>
                  </div>
                  <EstimateList
                    :item="item"
                    :storeInfo="item.estimateStore"
                    :selectIndex="index"
                    :mode="`VIEW`"
                    @moreReview="moreReview"
                    @goShopDetail="goShopDetail"
                    @goDetailView="goDetailView"
                    @enterChatRoom="enterChatRoom"
                    @mobileChat="mobileChat"
                  />
                </li>
              </ul>
              <ul class="list_vertical_ul" v-else-if="selectPayType == 'PLAN'">
                <li
                  class="list_item"
                  v-for="(item, index) in mobileEstimateGroupList.content.plans"
                  :key="index"
                >
                  <div
                    class="tag"
                    :class="{ best: index === 0 }"
                    v-if="index < 2"
                  >
                    <p>{{ index + 1 }}등</p>
                  </div>
                  <EstimateList
                    :item="item"
                    :storeInfo="item.estimateStore"
                    :selectIndex="index"
                    :mode="`VIEW`"
                    @moreReview="moreReview"
                    @goShopDetail="goShopDetail"
                    @goDetailView="goDetailView"
                    @enterChatRoom="enterChatRoom"
                    @mobileChat="mobileChat"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="prog_sec" v-else>
          <div class="no_reasult no_estimate">
            <div v-if="isStatus == 'ING'">
              <img
                :src="
                  require('@/assets/front/images/v2/character/img_empty_request.png')
                "
              />

              <p>
                아직 받은 견적이 없습니다.<br />지금 매장들은 견적을 작성
                중이에요!
              </p>
            </div>
            <div v-else>
              <img
                :src="
                  require('@/assets/front/images/v2/character/img_empty_result.png')
                "
              />

              <p>받은 견적이 없습니다.<br />견적 요청을 다시 해 주세요!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '마감하기 (모집완료)',
        type: 'confirm',
        msg: `마감 시 최초 견적요청일로부터 일주일이<br /> 지나야만 재요청이 가능합니다.<br /><br />마감을 진행할까요?`,
      }"
      @close="popupClose"
    />
    <ListSortModal
      :show="isListSortOpen"
      @close="listSortModalClose"
      ref="listSortModal"
    />
    <SafePhoneModal
      ref="safePhoneModal"
      @close="closeSafePhoneModal"
      @agreeChat="agreeChat"
      @normalChat="normalChat"
    ></SafePhoneModal>
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import ListSortModal from '@/front/customer/views/mobile/modal/ListSortModal';
import NoticeModal from '@/front/customer/views/mobile/modal/NoticeModal';
import SafePhoneModal from '@/front/customer/views/mobile/modal/SafePhoneModal';
import EstimateList from '@/front/customer/views/mobile/components/EstimateList';

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as safeNumberMapActions,
  mapGetters as safeNumberMapGetters,
} from '@common/store/modules/safeNumber';
import * as safeNumberTypes from '@common/store/modules/safeNumber/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import IngList from '@/front/customer/views/mobile/components/IngList';
import EndList from '@/front/customer/views/mobile/components/EndList';

export default {
  name: 'MobileEstimateView',
  components: {
    IngList,
    // EndList,
    DesignPopup2,
    ListSortModal,
    SafePhoneModal,
    EstimateList,
  },
  data() {
    return {
      isCompleted: false,
      mobileRequestList: {
        content: [],
      },
      isListSortOpen: false,
      designPopup: false,
      isSelectId: 0,
      isListSelectIndex: 0,
      isVisitSelectId: 0,
      isVisitSelectIndex: 0,
      isSetClosingBtn: false,
      // designPopup: false,
      isStatus: '',
      listSortTxt: '총 납부액 낮은 순',
      listSortVal: 'PRICE_ASC',
      selectPayType: '',
      size: 100,
      page: 1,
      listIndex: 0,
      chatCnt: 0,
      selectStoreId: 0,
      visitPage: 0, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      isVisitName: [
        'Mobile.EstimateDetail',
        'chat.room',
        'Shops.Reviews',
        'Shops.Detail',
      ], // 뒤로 이동시 가능한 방문 페이지 정리
      visitCheck: false,
      isSlideIndex: 0,
      compareDataSupport: [
        { store: '', totalMoney: 0 },
        { store: '', totalMoney: 0 },
      ],
      compareDataPlan: [
        { store: '', totalMoney: 0 },
        { store: '', totalMoney: 0 },
      ],
      supportsCount: 0,
      plansCount: 0,
      createRoom: '',
    };
  },
  async created() {
    if (!this.$route.query.id || !this.$route.query.status) {
      this.$router.go(-1);
    }

    this.isSelectId = this.$route.query.id;
    this.isStatus = this.$route.query.status;
    this.isSlideIndex = Number(this.$route.query.isSlideIndex) || 0;

    console.log('isSelectId = ' + this.isSelectId);
    console.log('isListSelectIndex = ' + this.isListSelectIndex);

    if (this.isStatus == 'ING') {
      await this.getRequestListIng();

      this.mobileRequestList = this.mobileRequestListIng;

      this.isSetClosingBtn = true;
    } else {
      await this.getRequestView();
      this.mobileRequestList.content.push(this.mobileRequestView);
    }

    var index = 0;
    let idArr = this.mobileRequestList.content.filter(i => {
      if (i.id == this.isSelectId) {
        this.isListSelectIndex = index;
      }

      index++;

      return i.id == this.isSelectId;
    });

    console.log('isSelectId == ' + this.isSelectId);
    console.log('isListSelectIndex == ' + this.isListSelectIndex);

    console.log('this.mobileRequestList');
    console.log(this.mobileRequestList);
    console.log('isListSelectIndex : {}', this.isListSelectIndex);

    localStorage.removeItem('mobileListIndex');
    await this.getEstimateList();

    this.isCompleted = true;

    // if (this.scrollLocation > 0) {
    //   setTimeout(() => {
    //     this.$refs.main_con.scrollTo(0, this.scrollLocation);
    //     this.scrollLocation = 0;
    //   }, 10);
    // }

    this.$nextTick(() => {
      setTimeout(() => {
        console.log(this.$refs.ing_list);
        if (this.visitCheck) {
          this.$refs.ing_list.$refs.mySwiper.$swiper.slideTo(this.isSlideIndex);
          this.$refs.ing_list.tabSelect(this.isListSelectIndex);

          this.$refs.main_con.scrollTo(0, this.scrollLocation);
          this.scrollLocation = 0;
        }
      }, 50);
    });
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  watch: {},
  mounted() {},
  updated() {},
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
      mobileRequestView: mobileTypes.MOBILE_REQUEST_VIEW,
      // mobileEstimateList: mobileTypes.MOBILE_ESTIMATE_LIST,
      mobileEstimateGroupList: mobileTypes.MOBILE_ESTIMATE_GROUP_LIST,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
    ...safeNumberMapGetters({
      safeNumber: safeNumberTypes.SAFE_NUMBER,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_VIEW,
      mobileTypes.UPDATE_MOBILE_REQUEST_CLOSE,
      mobileTypes.SELECT_MOBILE_ESTIMATE_LIST,
      mobileTypes.SELECT_MOBILE_ESTIMATE_GROUP_LIST,
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
      chatActions.SEND_MOBILE_REQUEST,
      chatActions.FETCH_CHATROOM_CHATLISTTYPE,
      chatActions.CREATE_CHATROOM,
    ]),
    ...safeNumberMapActions([safeNumberTypes.GET_SAFE_NUMBER]),
    setClosing() {
      this.designPopup = true;
    },
    popupClose(checked) {
      if (checked) {
        const params = {
          id: this.isSelectId,
        };
        this[mobileTypes.UPDATE_MOBILE_REQUEST_CLOSE](params).then(() => {
          this.isSetClosingBtn = true;
          this.$router.go(-1);
        });
      }
      this.designPopup = false;
    },
    async getRequestListIng() {
      let params = {
        page: this.page,
        size: 10,
        callPart: 'CUSTOMER',
        status: 'ING',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING](params);

      console.log(params);

      console.log('mobileRequestListIng');
      console.log(this.mobileRequestListIng);
    },
    async getRequestView() {
      let params = {
        callPart: 'CUSTOMER',
        id: this.isSelectId,
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_VIEW](params);

      var expireAt = format(
        parseISO(this.mobileRequestView.expireAt),
        'yyyy-MM-dd HH:mm:ss',
      );

      var now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      // console.log(now < expireAt);
      // console.log(format(new Date(), 'yyyy-MM-dd HH:mm:ss'));

      if (now < expireAt) {
        this.isExpired = false;
      } else {
        this.isExpired = true;
      }

      console.log(params);

      console.log('mobileRequestView');
      console.log(this.mobileRequestView);
    },
    async getEstimateList() {
      console.log(this.isSelectId);
      const params = {
        callPart: 'CUSTOMER',
        requestId: parseInt(this.isSelectId, 10),
        payType: '',
        orderType: this.listSortVal,
        page: this.page,
        size: this.size,
      };
      // await this[mobileTypes.SELECT_MOBILE_ESTIMATE_LIST](params);

      // console.log(params);
      // console.log('mobileEstimateList');
      // console.log(this.mobileEstimateList);

      await this[mobileTypes.SELECT_MOBILE_ESTIMATE_GROUP_LIST](params);

      console.log('this.mobileEstimateGroupList');
      console.log(this.mobileEstimateGroupList);

      this.supportsCount = this.mobileEstimateGroupList.content.supportsCount;
      this.plansCount = this.mobileEstimateGroupList.content.plansCount;

      if (!this.selectPayType) {
        if (this.supportsCount >= this.plansCount) {
          this.selectPayType = 'SUPPORT';
        } else {
          this.selectPayType = 'PLAN';
        }
      }

      await this.setCompareData();

      console.log('this.compareDataSupport');
      console.log(this.compareDataSupport);

      console.log('this.compareDataPlan');
      console.log(this.compareDataPlan);
    },
    async setCompareData() {
      this.compareDataPlan[0].store = '';
      this.compareDataPlan[1].store = '';
      this.compareDataPlan[0].totalMoney = 0;
      this.compareDataPlan[1].totalMoney = 0;

      if (this.supportsCount >= 2 && this.listSortVal == 'PRICE_ASC') {
        this.compareDataSupport[0].store = this.mobileEstimateGroupList.content.supports[0].estimateStore.storeName;
        this.compareDataSupport[1].store = this.mobileEstimateGroupList.content.supports[1].estimateStore.storeName;
        this.compareDataSupport[0].totalMoney = this.mobileEstimateGroupList.content.supports[0].totalMoney;
        this.compareDataSupport[1].totalMoney = this.mobileEstimateGroupList.content.supports[1].totalMoney;
      }
      if (this.plansCount >= 2 && this.listSortVal == 'PRICE_ASC') {
        this.compareDataPlan[0].store = this.mobileEstimateGroupList.content.plans[0].estimateStore.storeName;
        this.compareDataPlan[1].store = this.mobileEstimateGroupList.content.plans[1].estimateStore.storeName;
        this.compareDataPlan[0].totalMoney = this.mobileEstimateGroupList.content.plans[0].totalMoney;
        this.compareDataPlan[1].totalMoney = this.mobileEstimateGroupList.content.plans[1].totalMoney;
      }
    },
    listSortOpen() {
      this.isListSortOpen = true;
    },
    async listSortModalClose(checked) {
      if (checked) {
        this.listSortTxt = this.$refs.listSortModal.selectSortTxt;
        this.listSortVal = this.$refs.listSortModal.selectSortVal;

        await this.getEstimateList();

        console.log('listSortTxt:: {}', this.listSortTxt);
        console.log('listSortVal:: {}', this.listSortVal);
      }

      this.isListSortOpen = false;
    },
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getDateAt(dateAt) {
      return format(parseISO(dateAt), 'yyyy-MM-dd');
    },
    goShopDetail(id) {
      this.setLocation();
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: id,
        },
        query: {
          bottomBtn: 'hidden',
        },
      });
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '20');

      return path;
    },
    async enterChatRoom(storeId, chatCnt) {
      console.log(storeId);
      console.log(chatCnt);
      this.chatCnt = chatCnt;
      this.setLocation();
      await this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      }).then(() => {
        let name = 'chat.room';
        const params = {};
        if (this.chatroom_with.count == 0) {
          // name = 'chat.room.create';

          this[chatActions.CREATE_CHATROOM]({
            chatRoomType: 'OneOnOne',
            memberId: '',
            storeId: storeId,
            estimateId: undefined,
          }).then(() => {
            console.log('this.chatroom');
            console.log(this.chatroom);
            params.uuid = this.chatroom.uuid;
            params.createRoom = this.createRoom;

            // // 시스템 메세지 생성
            // this[chatActions.MESSAGE_NOTICE](noticeParams)
            this.$router.push({
              name,
              params,
            });
          });
        } else {
          params.uuid = this.chatroom_with.content[0].uuid;
          params.createRoom = this.createRoom;

          if (this.chatCnt == 0) {
            // 휴대폰 채팅 체크
            this[chatActions.FETCH_CHATROOM_CHATLISTTYPE]({
              chatListType: 'P',
              chatRoomId: this.chatroom_with.content[0].id,
            });
          }
          this.$router.push({
            name,
            params,
          });
        }
      });
    },
    async mobileChat(index, chatCnt) {
      this[safeNumberTypes.GET_SAFE_NUMBER]({})
        .then(() => {
          this.$refs.safePhoneModal.safeNumber = this.safeNumber;
        })
        .catch(() => {});
      this.chatCnt = chatCnt;
      this.listIndex = index;
      this.$refs.safePhoneModal.isOpen = true;
      util.nativeDisableBackKey();
    },
    setLocation() {
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      let scrollLocation = this.$refs.main_con.scrollTop; // 현재 스크롤바 위치

      const visit_page = {
        page: this.page,
        scrollLocation: scrollLocation,
        selectPayType: this.selectPayType,
        listSortVal: this.listSortVal,
        listSortTxt: this.listSortTxt,
        isSelectId: this.isSelectId,
        isListSelectIndex: this.isListSelectIndex,
        isSlideIndex: this.isSlideIndex,
      };

      localStorage.setItem(
        'visit_mobile_view_from_another',
        JSON.stringify(visit_page),
      );
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝
    },
    moreReview(storeId) {
      this.setLocation();
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: storeId },
        query: { type: 'normal' },
      });
    },
    showDetailView(index, type = '') {
      if (type == 'move') {
        var btnDetailElement = document.querySelector('.btn_detail.on');

        if (btnDetailElement != null) {
          btnDetailElement.classList.remove('on');
        }

        var moreInfoElement = document.querySelector('.more_info.on');

        if (moreInfoElement != null) {
          moreInfoElement.classList.remove('on');
        }
      }
      var btnSomeElement = document.getElementById(`btn_detail_${index}`);
      btnSomeElement.classList.toggle('on');

      var infoSomeElement = document.getElementById(`more_info_${index}`);
      infoSomeElement.classList.toggle('on');
    },
    goDetailView(id) {
      this.setLocation();
      const params = {
        requestId: parseInt(this.isSelectId, 10),
        estimateId: id,
        type: 'VIEW',
      };

      this.$router.push({ name: 'Mobile.EstimateDetail', query: params });
    },
    closeSafePhoneModal() {
      util.nativeEnableBackKey();
      this.$refs.safePhoneModal.isOpen = false;
    },
    async agreeChat() {
      await this.chatSend('agree');
      await this.enterChatRoom(this.selectStoreId, 0);
    },
    async normalChat() {
      await this.chatSend('normal');
      await this.enterChatRoom(this.selectStoreId, 0);
    },
    async chatSend(sel) {
      var sendSafeNum = '';
      var sendType = '';

      if (sel == 'agree') {
        // 동의하고 상담하기
        sendSafeNum = this.$refs.safePhoneModal.safeNumber;
      } else if (sel == 'normal') {
        // 단순 상담만 진행
        sendSafeNum = '';
      }

      // console.log('selectStoreId::: {}', selectStoreId);

      let estimateId = '';
      let requestId = '';
      if (this.selectPayType == 'SUPPORT') {
        this.selectStoreId = this.mobileEstimateGroupList.content.supports[
          this.listIndex
        ].storeId;

        estimateId = this.mobileEstimateGroupList.content.supports[
          this.listIndex
        ].id;

        requestId = this.mobileEstimateGroupList.content.supports[
          this.listIndex
        ].requestId;
      } else if (this.selectPayType == 'PLAN') {
        this.selectStoreId = this.mobileEstimateGroupList.content.plans[
          this.listIndex
        ].storeId;

        estimateId = this.mobileEstimateGroupList.content.plans[this.listIndex]
          .id;

        requestId = this.mobileEstimateGroupList.content.plans[this.listIndex]
          .requestId;
      }

      await this.chatroomCreateCheck(this.selectStoreId);

      const params = {
        callTime: this.$refs.safePhoneModal.timeValue,
        estimateId: estimateId,
        requestId: requestId,
        safeNum: sendSafeNum,
        sendType: sel,
        storeId: this.selectStoreId,
      };

      console.log(params);

      await this[chatActions.SEND_MOBILE_REQUEST](params);
    },
    setSlideIndex(index, isSelectId, listSelectIndex) {
      // alert(index);

      this.isSlideIndex = index;
      this.isSelectId = isSelectId;
      this.isListSelectIndex = listSelectIndex;
      this.setLocation();
      this.getEstimateList();
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy.MM.dd HH:mm');
    },
    selectTab(payType) {
      if (payType == 'SUPPORT') {
        this.$refs.tab_support.classList.add('on');
        this.$refs.tab_plan.classList.remove('on');
        this.selectPayType = 'SUPPORT';
      } else {
        this.$refs.tab_support.classList.remove('on');
        this.$refs.tab_plan.classList.add('on');
        this.selectPayType = 'PLAN';
      }
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_mobile_view_from_another',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          console.log('visit_page GET');
          console.log(visit_page);
          this.scrollLocation = visit_page.scrollLocation;
          this.visitCheck = true;
          this.selectPayType = visit_page.selectPayType;
          this.listSortTxt = visit_page.listSortTxt;
          this.listSortVal = visit_page.listSortVal;

          // this.isVisitSelectId = visit_page.isSelectId;
          // this.isVisitSelectIndex = visit_page.isListSelectIndex;

          this.isSelectId = visit_page.isSelectId;
          this.isListSelectIndex = visit_page.isListSelectIndex;
          this.isSlideIndex = visit_page.isSlideIndex;

          console.log('isSelectId ===== ' + this.isSelectId);
          console.log('isListSelectIndex ===== ' + this.isListSelectIndex);
        }
      } else {
        this.scrollLocation = 0;
        this.visitCheck = false;
        this.selectPayType = '';
      }

      // 데이터 담고 삭제
      await localStorage.removeItem('visit_mobile_view_from_another');
    },
    async chatroomCreateCheck(storeId) {
      await this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      }).then(() => {
        if (this.chatroom_with.count == 0) {
          this.createRoom = 'Y';
        }
      });
    },
  },
};
</script>
